var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"image-placeholder-container",class:{ 'no-image': !_vm.image },attrs:{"for":!_vm.disabled && _vm.target}},[(_vm.image)?_c('img',{staticClass:"image",attrs:{"src":_vm.image}}):[_c('span',[_vm._v(_vm._s(_vm.text))]),_c('i',{staticClass:"icon-cloud-upload"})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }